import { action } from "typesafe-actions"
import ActionTypes from "./constants"
import { QuicklookPreviewType } from "../../types/geoMap"

export const updateMapPositionAction = (value) => action(ActionTypes.UPDATE_MAP_POSITION, value)

export const removeLastShapeAction = () => action(ActionTypes.REMOVE_LAST_SHAPE)

export const convertLastShapeToPolygonTypeAction = () => action(ActionTypes.CONVERT_LAST_SHAPE_IN_POLYGON_TYPE)

export const removeKMLGuideShapeAction = () => action(ActionTypes.REMOVE_KML_SHAPE)

export const storeLastShapeAction = (data) => action(ActionTypes.STORE_LAST_SHAPE, data)

export const storeKMLGuideShapeAction = (data) => action(ActionTypes.STORE_KML_SHAPE, data)

export const setSuggestionsAction = (suggestions) => action(ActionTypes.SET_SUGGESTIONS, suggestions)

export const removeSuggestionsAction = () => action(ActionTypes.REMOVE_SUGGESTIONS)

export const setGeoMapAction = (map) => action(ActionTypes.SET_GEO_MAP, map)

export const addQuicklookPreviewAction = (
  quicklookPreview: QuicklookPreviewType
) => action(ActionTypes.ADD_QUICKLOOK_PREVIEW, quicklookPreview)

export const updateQuicklookPreviewsAction = (
  quicklookPreviews: QuicklookPreviewType[]
) => action(ActionTypes.UPDATE_QUICKLOOK_PREVIEWS, quicklookPreviews)

export const hideAllQuicklookPreviewsAction = () => action(ActionTypes.HIDE_ALL_QUICKLOOK_PREVIEWS)

export const setSearchMode = (search_mode) => action(ActionTypes.SET_SEARCH_BY_PRODUCTS, search_mode)

export const addLoadingScene = (loadingScene) => action(ActionTypes.ADD_LOADINGSCENE, loadingScene)
export const removeLoadingScene = (loadingSceneId) => action(ActionTypes.REMOVE_LOADINGSCENE, loadingSceneId)
export const addSceneToCut = (sceneToCut) => action(ActionTypes.ADD_SCENETOCUT, sceneToCut)
export const addCutScene = (cutscene) => action(ActionTypes.ADD_CUTSCENE, cutscene)
export const replaceLoadingScenes = (loadingScenes) => action(ActionTypes.REPLACE_LOADINGSCENES, loadingScenes)
export const replaceScenesToCut = (scenesToCut) => action(ActionTypes.REPLACE_SCENESTOCUT, scenesToCut)
export const replaceCutScenes = (cutscenes) => action(ActionTypes.REPLACE_CUTSCENES, cutscenes)
export const setSearchProductIds = (productIds) => action(ActionTypes.SET_SEARCH_PRODUCT_IDS, productIds)
export const changeRoutineStatusActionGeomap = (status) => action(ActionTypes.CHANGE_ROUTINE_STATUS, status);
